import { getApiBaseUrl } from '../utils/apiBaseUrl';

/**
 * Submit the contact form to the VBC API.
 * @param {Object} payload - Form data
 * @param {string} payload.name - Full name (e.g. "Jane Doe")
 * @param {string} payload.email - Email address
 * @param {string} payload.message - Message body
 * @param {string} [payload.phone] - Phone (optional)
 * @param {string} [payload.subject] - Subject (optional)
 * @param {string} [payload.SMSOPTIN] - SMS opt-in, e.g. "yes" (optional)
 * @returns {Promise<Object>} - Parsed JSON response from the API
 */
export async function submitContactForm(payload) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl ? `${baseUrl.replace(/\/$/, '')}/vbcsubmitcontactform/` : '/api/vbcsubmitcontactform/';
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await response.json();
  if (!response.ok) {
    const err = new Error(data.message || data.error || `Request failed with status ${response.status}`);
    err.status = response.status;
    err.data = data;
    throw err;
  }
  return data;
}
